import type { EventDateRange } from './types';

/** An event's link identifier: 16 random letters and digits, about 95 bits, made when the event is created and never changed. */
export const LINK_ID = /^[A-Za-z0-9]{16}$/;

export function slugify(input: string): string {
  return input
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export function firstDate(dates: EventDateRange[]): string | null {
  const starts = dates.map((d) => d.start).filter(Boolean).sort();
  return starts[0] ?? null;
}

/** e.g. `youth-conference-2026-06-12`: the readable end of a registration link. The event is found by its identifier alone. */
export function eventSlug(eventName: string, dates: EventDateRange[]): string {
  return [slugify(eventName), firstDate(dates)].filter(Boolean).join('-');
}

/** e.g. `r/n7Qk2mP9vR4xT8wB/youth-conference-2026-06-12` (no leading/trailing slash). */
export function registrationPath(linkId: string, eventName: string, dates: EventDateRange[]): string {
  const slug = eventSlug(eventName, dates);
  return `r/${linkId}${slug ? `/${slug}` : ''}`;
}

/** "Brushy Creek" -> "Brushy Creek Ward"; "Brushy Creek Ward" stays as-is. */
export function unitLabel(name: string, kind: 'Stake' | 'Ward' | 'Branch' | 'District'): string {
  const n = name.trim();
  return new RegExp(`\\b(stake|ward|branch|district)$`, 'i').test(n) ? n : `${n} ${kind}`;
}
